<template>
  <el-dialog
    width="40%"
    class="dialog"
    :title="type == 'add' ? '提交回收申请' : '预约派车'"
    :visible.sync="dialogFormVisible"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <el-form-item label="承运商" prop="carrierNo">
        <el-select
          v-model="formData.carrierNo"
          placeholder="请选择"
          clearable
          style="width: 100%"
          @change="changeCarrier"
          filterable
        >
          <el-option
            v-for="item in carrierOption"
            :key="item.partnershipId"
            :label="item.partnerName"
            :value="item.partnershipId.toString()"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="回收人员" prop="recoveryWorker">
        <el-select
          v-model="formData.recoveryWorker"
          placeholder="请选择"
          clearable
          style="width: 100%"
          filterable
          :disabled="!formData.carrierNo"
        >
          <el-option
            v-for="item in engineerList"
            :key="item.id"
            :label="item.name"
            :value="item.id.toString()"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目" class="read-only" prop="">{{
        projectDetails
      }}</el-form-item>
      <el-form-item label="地址" class="read-only" prop="address">{{
        fullAddress
      }}</el-form-item>
      <el-form-item label="回收数量" class="read-only" prop="orderCount">{{
        formData.orderCount
      }}</el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :disabled="btnLoading" @click="submitBtnFun"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import {
  getOldMachineRepertoryDetail,
  saveRecoveryApply,
  getEngineerList,
  getPartnerList
} from "@/api/COldForNew";

export default {
  components: {},
  data() {
    return {
      partnershipType: null, //当前用户所属组织 1 子公司 2 第三方 3 总公司
      dialogFormVisible: false,
      type: "add", //add 创建回收单模式 edit改派模式
      orderNo: "", //订单 id 改派的时候需要
      engineerList: [], //回收师傅待选列表
      recycleNo: undefined,
      formData: {
        /**
         * 承运商
         */
        carrierName: undefined,
        /**
         * 承运商
         */
        carrierNo: undefined,
        /**
         * 回收人员id
         */
        recoveryWorker: undefined,
        /**
         * 回收人电话
         */
        recoveryWorkerMobile: undefined,
        /**
         * 回收人名字
         */
        recoveryWorkerName: undefined,
        /**
         * 回收单号
         */
        recycleNo: undefined
      },
      pickerData: undefined, //对应日期的时间段
      carrierOption: [], //承运商待选列表
      rules: {
        carrierNo: [
          {
            required: true,
            message: "请选择承运商",
            trigger: "blur"
          }
        ],
        recoveryWorker: [
          {
            required: true,
            message: "请选择回收师傅",
            trigger: "blur"
          }
        ]
      },
      btnLoading: false
    };
  },
  watch: {},
  computed: {
    projectDetails() {
      return `${this.formData.projectNo || ""} ${this.formData.projectName ||
        ""}`;
    },
    fullAddress() {
      return `${this.formData.province || ""}${this.formData.city || ""}${this
        .formData.county || ""}${this.formData.address || ""} ${this.formData.contactName || ""} ${this.formData.contactMobile || ""}` ;
    }
  },
  watch: {
    dialogFormVisible: function(val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    }
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },

    // 打开弹框
    async openDialog(rowData, flag) {
      this.type = flag;
      this.partnershipType = JSON.parse(
        localStorage.getItem("partnershipType")
      );
      this.pickerData = "";
      this.btnLoading = false;
      if (flag == "edit") {
        //派车改派（回收订单列表发起）
        this.recycleNo = rowData.recycleNo;
      }
      await this.getDetail();
      await this.getPartnerList();
      await this.getEngineerList();

      this.dialogFormVisible = true;
    },
    //获取回收师傅列表（基于承运商id）
    async getEngineerList() {
      if (!this.formData.carrierNo) {
        return;
      }

      let { statusCode, data } = await getEngineerList(this.formData.carrierNo);
      if (statusCode == 200) {
        this.engineerList = data || [];
      }
    },
    //获取回收详情 用于改派或者提交回收单
    async getDetail() {
      let { statusCode, data } = await getOldMachineRepertoryDetail(
        this.recycleNo
      );
      if (statusCode == 200) {
        this.formData = data.oldMachineRecycle;
      }
      this.btnLoading = false;
    },
    // 确认提交
    submitBtnFun() {
      if (!this.pickerData && this.type == "add") {
        this.$message.warning("请选择预约时间段");
        return;
      }

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          const selectedCarrier = this.carrierOption.find(
            item => item.partnershipId.toString() === this.formData.carrierNo
          );
          this.formData.carrierName = selectedCarrier
            ? selectedCarrier.partnerName
            : "";

          const selectedEngineer = this.engineerList.find(
            item => item.id.toString() === this.formData.recoveryWorker
          );
          this.formData.recoveryWorkerName = selectedEngineer
            ? selectedEngineer.name
            : "";
          this.formData.recoveryWorkerMobile = selectedEngineer
            ? selectedEngineer.phone
            : "";

          if (this.type == "edit") {
            //预约改派
            this.editFormDataReq();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //改派接口
    async editFormDataReq() {
      let { statusCode, message } = await saveRecoveryApply(this.formData);
      if (statusCode == 200) {
        this.$message.success("操作成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      } else {
        this.$message.error(message);
      }
      this.btnLoading = false;
    },
    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields();
    },
    //更换承运商需要重新请求师傅列表
    async changeCarrier() {
      this.formData.recoveryWorker = undefined;
      if (this.carrierOption.length && this.formData.carrierNo) {
        const selectedCarrier = this.carrierOption.find(
          item => item.carrierNo == this.formData.carrierNo
        );
        this.formData.carrierName = selectedCarrier
          ? selectedCarrier.carrierName
          : "";
      }
      this.engineerList = []; //清空旧工程师列表
      this.getEngineerList();
    },
    //获取承运商
    async getPartnerList() {
      const params = {
        currPage: 1,
        pageSize: 10000
      };
      let { statusCode, data } = await getPartnerList(params);
      if (statusCode == 200) {
        this.carrierOption = data;
      } else {
        this.carrierOption = [];
      }
    },
    //更改了日期
    changeDate() {
      this.pickerData = "";
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/COldForNewService/components/appointmentDialog.vue